import { DayPicker, type DayPickerProps } from "react-day-picker";
import "react-day-picker/style.css";

import { cn } from "@/lib/utils";

/**
 * Thin wrapper around react-day-picker v9. Exposes the shadcn `--primary` /
 * `--accent` tokens to react-day-picker's `--rdp-*` variables so the calendar
 * matches the rest of the app's theme.
 */
export type CalendarProps = DayPickerProps;

function Calendar({ className, classNames, ...props }: CalendarProps) {
  return (
    <DayPicker
      className={cn(
        // Map react-day-picker's CSS variables to our shadcn tokens.
        "[--rdp-accent-color:hsl(var(--primary))]",
        "[--rdp-accent-background-color:hsl(var(--accent))]",
        "[--rdp-day-height:36px] [--rdp-day-width:36px]",
        "[--rdp-day_button-height:34px] [--rdp-day_button-width:34px]",
        "[--rdp-nav_button-height:28px] [--rdp-nav_button-width:28px]",
        "p-3 text-sm",
        className,
      )}
      classNames={classNames}
      {...props}
    />
  );
}
Calendar.displayName = "Calendar";

export { Calendar };
